function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Invite = require('./invite');
var InviteManagerTemplate = require('./invite-container.template');
var JSON = require('json-bigint');
var LoungeOverlay = require('./overlays/lounge');
var InviteManager = /*#__PURE__*/function () {
  function InviteManager(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, InviteManager);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.name = 'InviteManager';
    this.type = 'short';
    this.list = 'all';
    this.lists = ['mine', 'open', 'active'];
    if (mod !== null && mod !== void 0 && mod.sudo) {
      console.info('ARCADE Sudo mode! Should show all games in UI');
      this.lists = ['mine', 'open', 'active', 'private', 'close', 'over'];
    }
    this.game_filter = null;
  }
  return _createClass(InviteManager, [{
    key: "render",
    value: function render() {
      var _this$mod;
      //
      // replace element or insert into page (deletes invites for a full refresh)
      //
      var target = this.container + ' .arcade-invite';
      if (document.querySelector(target)) {
        this.app.browser.replaceElementBySelector(InviteManagerTemplate(this.app, this.mod), target);
      } else {
        this.app.browser.addElementToSelector(InviteManagerTemplate(this.app, this.mod), this.container);
      }
      var rendered_content = false;
      var _iterator = _createForOfIteratorHelper(this.lists),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var list = _step.value;
          if (this.list === 'all' || this.list === list) {
            var listGames = this.mod.returnGamesWithFilter({
              status: list
            }).map(function (r) {
              return r.tx;
            });
            if (listGames.length > 0 && !this.game_filter) {
              if (list === 'mine') {
                this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">My Games</h5>", target);
              } else if (list == 'open') {
                this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">Open Invites</h5>", target);
              } else if (list == 'active') {
                var valid_open_games = false;
                for (var _i = 0; _i < listGames.length; _i++) {
                  if (listGames[_i].msg.options['open-table']) {
                    valid_open_games = true;
                  }
                }
                if (valid_open_games) {
                  this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">Active Matches</h5>", target);
                }
              } else if (list == 'over') {
                this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">Recent Matches</h5>", target);
              } else {
                this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">".concat(list.charAt(0).toUpperCase() + list.slice(1), " Games</h5>"), target);
              }
            }
            for (var _i2 = 0; _i2 < listGames.length && _i2 < 15; _i2++) {
              if (!(this !== null && this !== void 0 && this.game_filter) || this.game_filter == listGames[_i2].msg.game) {
                if (list == 'active' && !listGames[_i2].msg.options['open-table'] && !this.mod.sudo) {
                  continue;
                }
                var _newInvite = new Invite(this.app, this.mod, target, this.type, listGames[_i2], this.mod.publicKey);
                if (this.app.modules.returnModuleByName(_newInvite.invite_data.game_name)) {
                  if (_newInvite.invite_data.league) {
                    var _this$mod$leagueCallb2;
                    if (!((_this$mod$leagueCallb2 = this.mod.leagueCallback) !== null && _this$mod$leagueCallb2 !== void 0 && _this$mod$leagueCallb2.testMembership(_newInvite.invite_data.league))) {
                      continue;
                    }
                  }
                  _newInvite.render();
                  rendered_content = true;
                }
              }
            }
          }
        }

        // Sudo: group records where sender is unreachable, label "Offline"
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.sudo && this.list === 'all') {
        var offlineGames = this.mod.returnGamesWithFilter({
          is_sender_reachable: false
        }).map(function (game) {
          return game.tx;
        });
        if (offlineGames.length > 0 && !this.game_filter) {
          this.app.browser.addElementToSelector("<h5 class=\"sidebar-header\">Offline</h5>", target);
        }
        for (var i = 0; i < offlineGames.length && i < 15; i++) {
          if (!(this !== null && this !== void 0 && this.game_filter) || this.game_filter == offlineGames[i].msg.game) {
            var newInvite = new Invite(this.app, this.mod, target, this.type, offlineGames[i], this.mod.publicKey);
            if (this.app.modules.returnModuleByName(newInvite.invite_data.game_name)) {
              if (newInvite.invite_data.league) {
                var _this$mod$leagueCallb;
                if (!((_this$mod$leagueCallb = this.mod.leagueCallback) !== null && _this$mod$leagueCallb !== void 0 && _this$mod$leagueCallb.testMembership(newInvite.invite_data.league))) {
                  continue;
                }
              }
              newInvite.render();
              rendered_content = true;
            }
          }
        }
      }

      //
      // remove unneeded
      //
      this.mod.purge();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = InviteManager;